import { API_BASE } from './apiBase';
import { duelPlayerId } from './duelInbox';

// Kept out of duel.ts (which pulls in the question bank) so the homepage and
// stats screen can show ratings without downloading every question.

// Your duel rating per category. Cached so tiles show it instantly; refreshed
// from the server (the source of truth) whenever the duel screen opens.
export interface CategoryRating { rating: number; games: number; peak: number }
const RATINGS_KEY = 'bf_ratings';

export function cachedRatings(): Record<string, CategoryRating> {
  try {
    return JSON.parse(localStorage.getItem(RATINGS_KEY) || '{}');
  } catch {
    return {};
  }
}

export function cacheRating(category: string, rating: CategoryRating) {
  try {
    localStorage.setItem(RATINGS_KEY, JSON.stringify({ ...cachedRatings(), [category]: rating }));
  } catch { /* ignore */ }
}

export async function fetchRatings(): Promise<Record<string, CategoryRating>> {
  const res = await fetch(`${API_BASE}/api/duel/ratings?player=${encodeURIComponent(duelPlayerId())}`);
  if (!res.ok) throw new Error(`ratings ${res.status}`);
  const { ratings } = await res.json() as { ratings: Record<string, CategoryRating> };
  try { localStorage.setItem(RATINGS_KEY, JSON.stringify(ratings)); } catch { /* ignore */ }
  return ratings;
}
